/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AccountingConfigurationConnectionDto,
  AccountingProfileDto,
  GetProfileFieldOptionsParams,
  ProfileFieldUpdateRequest,
  SelectOptionDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class AccountingConnectionController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags accounting-connection-controller
   * @name UpdateProfileField
   * @request PATCH:/api/v2/accounting-connection/profile/fields/{fieldId}
   */
  updateProfileField = (
    fieldId: string,
    data: ProfileFieldUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<AccountingProfileDto, any>({
      path: `/v2/accounting-connection/profile/fields/${fieldId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateProfileFieldPath = '/v2/accounting-connection/profile/fields/${fieldId}'
  static updateProfileFieldMethod = 'PATCH'
  /**
   * No description
   *
   * @tags accounting-connection-controller
   * @name GetConnection
   * @request GET:/api/v2/accounting-connection
   */
  getConnection = (params: RequestParams = {}) =>
    this.http.request<AccountingConfigurationConnectionDto, any>({
      path: `/v2/accounting-connection`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getConnectionPath = '/v2/accounting-connection'
  static getConnectionMethod = 'GET'
  /**
   * No description
   *
   * @tags accounting-connection-controller
   * @name GetConnectionProfile
   * @request GET:/api/v2/accounting-connection/profile
   */
  getConnectionProfile = (params: RequestParams = {}) =>
    this.http.request<AccountingProfileDto, any>({
      path: `/v2/accounting-connection/profile`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getConnectionProfilePath = '/v2/accounting-connection/profile'
  static getConnectionProfileMethod = 'GET'
  /**
   * No description
   *
   * @tags accounting-connection-controller
   * @name DeleteAccountingProfile
   * @request DELETE:/api/v2/accounting-connection/profile
   */
  deleteAccountingProfile = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v2/accounting-connection/profile`,
      method: 'DELETE',
      ...params,
    })

  static deleteAccountingProfilePath = '/v2/accounting-connection/profile'
  static deleteAccountingProfileMethod = 'DELETE'
  /**
   * No description
   *
   * @tags accounting-connection-controller
   * @name ConnectionProfileEnabled
   * @request GET:/api/v2/accounting-connection/profile/profile-enabled
   */
  connectionProfileEnabled = (params: RequestParams = {}) =>
    this.http.request<boolean, any>({
      path: `/v2/accounting-connection/profile/profile-enabled`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static connectionProfileEnabledPath = '/v2/accounting-connection/profile/profile-enabled'
  static connectionProfileEnabledMethod = 'GET'
  /**
   * No description
   *
   * @tags accounting-connection-controller
   * @name GetProfileFieldOptions
   * @request GET:/api/v2/accounting-connection/profile/fields/{fieldId}/options
   */
  getProfileFieldOptions = (
    { fieldId, ...query }: GetProfileFieldOptionsParams,
    params: RequestParams = {},
  ) =>
    this.http.request<SelectOptionDto[], any>({
      path: `/v2/accounting-connection/profile/fields/${fieldId}/options`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getProfileFieldOptionsPath = '/v2/accounting-connection/profile/fields/${fieldId}/options'
  static getProfileFieldOptionsMethod = 'GET'
}
